import React from 'react';

class Marker extends React.Component {
    getStyles(position, containerSize) {
        let styles = {
            top: `${position.y}px`,
            left: `${position.x}px`
        };

        if (containerSize && Object.keys(containerSize).length > 0) {
            styles = {
                top: `${(position.y * 100) / containerSize.height}%`,
                left: `${(position.x * 100) / containerSize.width}%`
            }
        }

        return styles;
    }

    render() {
        const {position, containerSize} = this.props;

        const markStyles = this.getStyles(position, containerSize);

        return (
            <span
                className="Marker"
                style={markStyles}>
            </span>
        )
    }
}

export default Marker;